export default "__VITE_ASSET__B$OE0UQF__"